import { AdminLinks } from '@app/modules/admin/routing/AdminLinks';
import { FleetLinks } from '@app/modules/fleet/routing/FleetLinks';
import { AuditLinks } from './audit/components/AuditLinks';
import { ContentAiLinks } from './content-ai/routing/ContentAiLinks';
import { ComposeLinks } from './compose/routing/ComposeLinks';
import { FragmentsLinks } from './fragments/routing/FragmentsLinks';
import { LoggerLinks } from './logger/LoggerLinks';
import { SearchLinks } from './search/routing/SearchLinks';

export function ModulesNavLinks() {
  return (
    <>
      <LoggerLinks />
      <FragmentsLinks />
      <ComposeLinks />
      <AuditLinks />
      <FleetLinks />
      <SearchLinks />
      <ContentAiLinks />
      <AdminLinks />
    </>
  );
}
